import http from "@/api/http.js";

export function getAlerts(filters) {
  const newFilters = Object.entries(filters)
    .map(([key, val]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    })
    .join("&");
  return http.get(`/alerts?${newFilters}`);
}

export function getAlert(alertId) {
  return http.get(`/alerts/single/${alertId}`);
}

export function hideAlert(alertId) {
  return http.get(`/alerts/set_hidden?hiddenStatus=1&id=${alertId}`);
}

export function unhideAlert(alertId) {
  return http.get(`/alerts/set_hidden?hiddenStatus=0&id=${alertId}`);
}

export function hideAllAlerts() {
  return http.get(`/alerts/set_all_hidden`);
}
